var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ui-file-preview"},[(_vm.preview && _vm.$file.isImage())?_c('img',{attrs:{"src":_vm.$file.getImageUrl()}}):_c('b-icon',{attrs:{"icon":_vm.$file.getIconName(),"type":_vm.$file.getIconType(),"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }